import { render, staticRenderFns } from "./BcbCampaignCustomerImport.vue?vue&type=template&id=d23260ac&scoped=true"
import script from "./BcbCampaignCustomerImport.vue?vue&type=script&lang=js"
export * from "./BcbCampaignCustomerImport.vue?vue&type=script&lang=js"
import style0 from "./BcbCampaignCustomerImport.vue?vue&type=style&index=0&id=d23260ac&prod&lang=scss&scoped=true"
import style1 from "./BcbCampaignCustomerImport.vue?vue&type=style&index=1&id=d23260ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23260ac",
  null
  
)

export default component.exports